import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

interface FeatureFlagMessageProps {
  className?: string;
}

const FeatureFlagMessage: React.FC<FeatureFlagMessageProps> = ({
  className,
}) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries } = contentfulData;
  const featureFlaggingMsg = entries?.rb_feature_flagging?.featureFlaggingMsg;
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(false);
    }, 3000);
  }, []);

  return (
    <>
      {isVisible && (
        <div
          className={`absolute left-0 top-auto right-0 z-50 bg-gray-400 text-white text-center ${className}`}
        >
          <p className="font-[400] text-[16px]" aria-label={featureFlaggingMsg}>
            {featureFlaggingMsg}
          </p>
        </div>
      )}
    </>
  );
};

export default FeatureFlagMessage;
